import { Injectable } from 'angular-ts-decorators';

/**
 * # Currencies
 * Service that wraps the currency list NPM module https://www.npmjs.com/package/currency-codes
 */

export interface ICurrency {
  code: string;
  number: string;
  digits: number;
  currency: string;
  countries: string[];
}

@Injectable('currencies')
export class Currencies {
  /**
   * Array with all currencies example value:
   * <pre>
   * {
   *    code: 'EUR',
   *    number: 978,
   *    digits: 2,
   *    currency: 'Euro',
   *    countries: [
   *        'andorra', 'austria', 'belgium', 'cyprus', 'estonia', 'finland',
   *        'france', 'germany', 'greece', 'ireland', 'italy', 'kosovo',
   *        'luxembourg', 'malta', 'monaco', 'montenegro', 'netherlands',
   *        'portugal', 'san marino', 'slovakia', 'slovenia', 'spain',
   *        'vatican city' ]
   * }
   * </pre>
   */
  list: ICurrency[];

  constructor() {
    'ngInject';

    this.list = require('currency-codes/data') as ICurrency[];
  }
}
